// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/projectdata/v1/capture_solution_reviews.proto (package mono.projectdata.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { CaptureSolutionEvidenceDecision, CaptureSolutionReview } from "../../datagateway/v1/capture_solution_reviews_pb";
/**
 * @generated from message mono.projectdata.v1.CheckCaptureSolutionReviewAccessRequest
 */ export class CheckCaptureSolutionReviewAccessRequest extends Message {
    static fromBinary(bytes, options) {
        return new CheckCaptureSolutionReviewAccessRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CheckCaptureSolutionReviewAccessRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CheckCaptureSolutionReviewAccessRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CheckCaptureSolutionReviewAccessRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string rfi_response_project_id = 2;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * read | update
   *
   * @generated from field: string action = 3;
   */ _define_property(this, "action", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CheckCaptureSolutionReviewAccessRequest, "runtime", proto3);
_define_property(CheckCaptureSolutionReviewAccessRequest, "typeName", "mono.projectdata.v1.CheckCaptureSolutionReviewAccessRequest");
_define_property(CheckCaptureSolutionReviewAccessRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "action",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CheckCaptureSolutionReviewAccessResponse
 */ export class CheckCaptureSolutionReviewAccessResponse extends Message {
    static fromBinary(bytes, options) {
        return new CheckCaptureSolutionReviewAccessResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CheckCaptureSolutionReviewAccessResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CheckCaptureSolutionReviewAccessResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CheckCaptureSolutionReviewAccessResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(CheckCaptureSolutionReviewAccessResponse, "runtime", proto3);
_define_property(CheckCaptureSolutionReviewAccessResponse, "typeName", "mono.projectdata.v1.CheckCaptureSolutionReviewAccessResponse");
_define_property(CheckCaptureSolutionReviewAccessResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.projectdata.v1.ListCaptureSolutionReviewsRequest
 */ export class ListCaptureSolutionReviewsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListCaptureSolutionReviewsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCaptureSolutionReviewsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCaptureSolutionReviewsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCaptureSolutionReviewsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCaptureSolutionReviewsRequest, "runtime", proto3);
_define_property(ListCaptureSolutionReviewsRequest, "typeName", "mono.projectdata.v1.ListCaptureSolutionReviewsRequest");
_define_property(ListCaptureSolutionReviewsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListCaptureSolutionReviewsResponse
 */ export class ListCaptureSolutionReviewsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListCaptureSolutionReviewsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCaptureSolutionReviewsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCaptureSolutionReviewsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCaptureSolutionReviewsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.CaptureSolutionReview reviews = 1;
   */ _define_property(this, "reviews", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCaptureSolutionReviewsResponse, "runtime", proto3);
_define_property(ListCaptureSolutionReviewsResponse, "typeName", "mono.projectdata.v1.ListCaptureSolutionReviewsResponse");
_define_property(ListCaptureSolutionReviewsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "reviews",
            kind: "message",
            T: CaptureSolutionReview,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetCaptureSolutionReviewRequest
 */ export class GetCaptureSolutionReviewRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetCaptureSolutionReviewRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCaptureSolutionReviewRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCaptureSolutionReviewRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCaptureSolutionReviewRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string review_id = 2;
   */ _define_property(this, "reviewId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCaptureSolutionReviewRequest, "runtime", proto3);
_define_property(GetCaptureSolutionReviewRequest, "typeName", "mono.projectdata.v1.GetCaptureSolutionReviewRequest");
_define_property(GetCaptureSolutionReviewRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "review_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetCaptureSolutionReviewResponse
 */ export class GetCaptureSolutionReviewResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetCaptureSolutionReviewResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCaptureSolutionReviewResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCaptureSolutionReviewResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCaptureSolutionReviewResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CaptureSolutionReview review = 1;
   */ _define_property(this, "review", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCaptureSolutionReviewResponse, "runtime", proto3);
_define_property(GetCaptureSolutionReviewResponse, "typeName", "mono.projectdata.v1.GetCaptureSolutionReviewResponse");
_define_property(GetCaptureSolutionReviewResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "review",
            kind: "message",
            T: CaptureSolutionReview
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.DecideCaptureSolutionReviewRequest
 */ export class DecideCaptureSolutionReviewRequest extends Message {
    static fromBinary(bytes, options) {
        return new DecideCaptureSolutionReviewRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DecideCaptureSolutionReviewRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DecideCaptureSolutionReviewRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DecideCaptureSolutionReviewRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string review_id = 2;
   */ _define_property(this, "reviewId", ""), /**
   * @generated from field: string request_id = 3;
   */ _define_property(this, "requestId", ""), /**
   * @generated from field: int64 expected_revision = 4;
   */ _define_property(this, "expectedRevision", protoInt64.zero), /**
   * @generated from field: string decision = 5;
   */ _define_property(this, "decision", ""), /**
   * @generated from field: string reason = 6;
   */ _define_property(this, "reason", ""), /**
   * @generated from field: string proposed_text = 7;
   */ _define_property(this, "proposedText", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DecideCaptureSolutionReviewRequest, "runtime", proto3);
_define_property(DecideCaptureSolutionReviewRequest, "typeName", "mono.projectdata.v1.DecideCaptureSolutionReviewRequest");
_define_property(DecideCaptureSolutionReviewRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "review_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "request_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "expected_revision",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 5,
            name: "decision",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "proposed_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.DecideCaptureSolutionReviewResponse
 */ export class DecideCaptureSolutionReviewResponse extends Message {
    static fromBinary(bytes, options) {
        return new DecideCaptureSolutionReviewResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DecideCaptureSolutionReviewResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DecideCaptureSolutionReviewResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DecideCaptureSolutionReviewResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CaptureSolutionEvidenceDecision decision = 1;
   */ _define_property(this, "decision", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DecideCaptureSolutionReviewResponse, "runtime", proto3);
_define_property(DecideCaptureSolutionReviewResponse, "typeName", "mono.projectdata.v1.DecideCaptureSolutionReviewResponse");
_define_property(DecideCaptureSolutionReviewResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "decision",
            kind: "message",
            T: CaptureSolutionEvidenceDecision
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RefreshCaptureSolutionReviewRequest
 */ export class RefreshCaptureSolutionReviewRequest extends Message {
    static fromBinary(bytes, options) {
        return new RefreshCaptureSolutionReviewRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RefreshCaptureSolutionReviewRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RefreshCaptureSolutionReviewRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RefreshCaptureSolutionReviewRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string review_id = 2;
   */ _define_property(this, "reviewId", ""), /**
   * @generated from field: int64 expected_revision = 3;
   */ _define_property(this, "expectedRevision", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RefreshCaptureSolutionReviewRequest, "runtime", proto3);
_define_property(RefreshCaptureSolutionReviewRequest, "typeName", "mono.projectdata.v1.RefreshCaptureSolutionReviewRequest");
_define_property(RefreshCaptureSolutionReviewRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "review_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "expected_revision",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RefreshCaptureSolutionReviewResponse
 */ export class RefreshCaptureSolutionReviewResponse extends Message {
    static fromBinary(bytes, options) {
        return new RefreshCaptureSolutionReviewResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RefreshCaptureSolutionReviewResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RefreshCaptureSolutionReviewResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RefreshCaptureSolutionReviewResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CaptureSolutionReview review = 1;
   */ _define_property(this, "review", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RefreshCaptureSolutionReviewResponse, "runtime", proto3);
_define_property(RefreshCaptureSolutionReviewResponse, "typeName", "mono.projectdata.v1.RefreshCaptureSolutionReviewResponse");
_define_property(RefreshCaptureSolutionReviewResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "review",
            kind: "message",
            T: CaptureSolutionReview
        }
    ]));
